import React from "react";
import { connect } from "react-redux";
import RegisteredAnimalsTable from "../components/RegisteredAnimalsTable";
import { ANIMAL_TYPE_SHEEP } from "variables/constants";

const Sheeps = ({filters}) => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
	      	<RegisteredAnimalsTable animalTypeId={ANIMAL_TYPE_SHEEP}/>
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	filters: state.farmAnimal.recordList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(Sheeps);
